// extracted by mini-css-extract-plugin
module.exports = {"talkswrapper":"talks-15-1_talkswrapper_32-sl","spinAround":"talks-15-1_spinAround_3YzIi"};